import { Label as LabelBase } from '../Label';
import { CmToFtAndInch } from '../../lengthConvertor';

export class Label extends LabelBase {

  update(radius: number) {
    super.updateText(CmToFtAndInch(radius));
    this.position.set(radius / 2, 0, -10);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Circle/Label.ts